
import { defineComponent } from 'vue';

const Dashboard = defineComponent({
  // setup() {},
});

export default Dashboard;
